var _regeneratorRuntime = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _require = require('factom'),
    Entry = _require.Entry,
    isValidPublicFctAddress = _require.isValidPublicFctAddress,
    isValidEcAddress = _require.isValidEcAddress,
    addressToRcdHash = _require.addressToRcdHash,
    rcdHashToPublicFctAddress = _require.rcdHashToPublicFctAddress;

var _require2 = require('./identity-chains'),
    getIdentityRootChain = _require2.getIdentityRootChain;

var _require3 = require('./common'),
    getNowTimestamp8BytesBuffer = _require3.getNowTimestamp8BytesBuffer,
    verify = _require3.verify,
    extractSecretFromIdentityKey = _require3.extractSecretFromIdentityKey,
    sign = _require3.sign;

var _require4 = require('../crypto'),
    sha256d = _require4.sha256d,
    secretToPublicKey = _require4.secretToPublicKey;

var _require5 = require('./validation'),
    isValidSk1 = _require5.isValidSk1,
    isValidServerIdentityChainId = _require5.isValidServerIdentityChainId;

var _require6 = require('./constant'),
    VERSION_0 = _require6.VERSION_0; ///////////////// Read /////////////////


function extract(rootChainId, rootEntries, identityKey1) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = rootEntries.reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var entry = _step.value;

      if (isValidCoinbaseAddressRegistration(entry, rootChainId, identityKey1)) {
        return {
          registrationEntryHash: entry.hash().toString('hex'),
          registrationTimestamp: entry.blockContext.entryTimestamp,
          registrationDirectoryBlockHeight: entry.blockContext.directoryBlockHeight,
          address: rcdHashToPublicFctAddress(entry.extIds[3])
        };
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function extractHistory(rootChainId, rootEntries, identityKey1) {
  return rootEntries.reverse().filter(function (e) {
    return isValidCoinbaseAddressRegistration(e, rootChainId, identityKey1);
  }).map(function (e) {
    return {
      registrationEntryHash: e.hash().toString('hex'),
      registrationTimestamp: e.blockContext.entryTimestamp,
      registrationDirectoryBlockHeight: e.blockContext.directoryBlockHeight,
      address: rcdHashToPublicFctAddress(e.extIds[3])
    };
  });
}

function isValidCoinbaseAddressRegistration(entry, rootChainId, identityKey1) {
  var extIds = entry.extIds;

  if (extIds.length !== 7 || !extIds[0].equals(VERSION_0) || extIds[1].toString() !== 'Coinbase Address' || extIds[2].toString('hex') !== rootChainId || !sha256d(extIds[5]).equals(identityKey1)) {
    return false;
  }

  var data = Buffer.concat(extIds.slice(0, 5));

  if (!verify(extIds[5], data, extIds[6])) {
    return false;
  }

  return true;
} ///////////////// Update /////////////////


function update(_x, _x2, _x3, _x4, _x5) {
  return _update.apply(this, arguments);
}
/**
 * Generate Entry object to update a server identity coinbase address.
 * @memberof server
 * @function generateCoinbaseAddressUpdateEntry
 * @param {string} rootChainId - Identity Root Chain Id.
 * @param {string} fctAddress - Public Factoid address to set as the new coinbase address.
 * @param {string} sk1 - Server identity Secret Key 1.
 * @returns {{{chainId: Buffer, extIds: Buffer[], content: Buffer}}}
 */


function _update() {
  _update = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(cli, rootChainId, fctAddress, sk1, ecAddress) {
    var balance, rootChain, identityKey, entry;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isValidSk1(sk1)) {
              _context.next = 2;
              break;
            }

            throw new Error('Lowest level identity key (sk1) is not valid');

          case 2:
            if (isValidPublicFctAddress(fctAddress)) {
              _context.next = 4;
              break;
            }

            throw new Error("Invalid public FCT address: ".concat(fctAddress));

          case 4:
            if (isValidEcAddress(ecAddress)) {
              _context.next = 6;
              break;
            }

            throw new Error("Invalid EC address ".concat(ecAddress));

          case 6:
            _context.next = 8;
            return cli.getBalance(ecAddress);

          case 8:
            balance = _context.sent;

            if (!(balance < 1)) {
              _context.next = 11;
              break;
            }

            throw new Error('Insufficient EC balance to pay for updating coinbase address');

          case 11:
            _context.next = 13;
            return getIdentityRootChain(cli, rootChainId);

          case 13:
            rootChain = _context.sent;
            identityKey = sha256d(Buffer.concat([Buffer.from('01', 'hex'), secretToPublicKey(extractSecretFromIdentityKey(sk1))]));

            if (rootChain.identityKeys[0].equals(identityKey)) {
              _context.next = 17;
              break;
            }

            throw new Error("The SK1 key cannot sign entries in the Identity Root Chain ".concat(rootChainId));

          case 17:
            entry = Entry.builder(getCoinbaseAddressUpdateEntry(rootChainId, fctAddress, sk1)).build();
            _context.next = 20;
            return cli.add(entry, ecAddress);

          case 20:
            return _context.abrupt("return", _context.sent);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _update.apply(this, arguments);
}

function generateUpdateEntry(rootChainId, fctAddress, sk1) {
  if (!isValidServerIdentityChainId(rootChainId)) {
    throw new Error("Invalid root chain id ".concat(rootChainId));
  }

  if (!isValidSk1(sk1)) {
    throw new Error('Lowest level identity key (sk1) is not valid');
  }

  if (!isValidPublicFctAddress(fctAddress)) {
    throw new Error("Invalid public FCT address: ".concat(fctAddress));
  }

  return getCoinbaseAddressUpdateEntry(rootChainId, fctAddress, sk1);
}

function getCoinbaseAddressUpdateEntry(rootChainId, fctAddress, sk1) {
  var version = Buffer.from('00', 'hex');
  var marker = Buffer.from('Coinbase Address', 'utf8');
  var chainId = Buffer.from(rootChainId, 'hex');
  var factoidAddress = addressToRcdHash(fctAddress);
  var timestamp = getNowTimestamp8BytesBuffer();
  var dataToSign = Buffer.concat([version, marker, chainId, factoidAddress, timestamp]);

  var _sign = sign(extractSecretFromIdentityKey(sk1), dataToSign),
      identityKeyPreImage = _sign.identityKeyPreImage,
      signature = _sign.signature;

  return {
    chainId: chainId,
    extIds: [version, marker, chainId, factoidAddress, timestamp, identityKeyPreImage, signature],
    content: Buffer.from('')
  };
}

module.exports = {
  update: update,
  extract: extract,
  extractHistory: extractHistory,
  generateUpdateEntry: generateUpdateEntry
};